"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurplusLineRow = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var box_1 = require("../../../../box");
var flexbox_1 = require("../../../../flexbox");
var icon_button_1 = require("../../../../icon-button");
var padding_1 = require("../../../../padding");
var advanced_select_input_1 = require("../../../../select-input/components/advanced-select-input");
var util_1 = require("../../../lib/util");
var editable_cell_1 = require("./editable-cell");
var table_1 = require("./table");
function SurplusLineRow(props) {
    var value = props.value, onChange = props.onChange, options = props.options, selectedOption = props.selectedOption, onDelete = props.onDelete, _a = props.hideFooter, hideFooter = _a === void 0 ? false : _a;
    var onSelectOptionChange = function (selectValue) {
        onChange({ item: selectValue, value: value !== null && value !== void 0 ? value : 0 });
    };
    return (react_1.default.createElement(table_1.StyledRow, { hideFooter: hideFooter, key: "styled-row-".concat(selectedOption) },
        react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center", style: { width: '100%', height: '100%' } },
            react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", width: "70%", gap: "8px" },
                react_1.default.createElement(box_1.Box, { style: { width: '70%' } },
                    react_1.default.createElement(padding_1.Padding, { size: 8 },
                        react_1.default.createElement(advanced_select_input_1.AdvancedSelectInput, { placeholder: "Select an option", options: options, onChange: onSelectOptionChange, value: selectedOption }))),
                react_1.default.createElement(icon_button_1.IconButton, { type: "remove", onClick: function () { return onDelete(); } })),
            react_1.default.createElement(editable_cell_1.EditableCell, { value: value !== null && value !== void 0 ? value : 0, isEditable: !!selectedOption, onChange: function (val) {
                    var roundedVal;
                    if (typeof val === 'number') {
                        roundedVal = (0, util_1.roundNumber)(val);
                    }
                    onChange({ item: selectedOption, value: roundedVal !== null && roundedVal !== void 0 ? roundedVal : 0 });
                }, testId: "editable-".concat(selectedOption), width: 130 }))));
}
exports.SurplusLineRow = SurplusLineRow;
//# sourceMappingURL=surplus-line-row.js.map